const { findSpriteByName } = require('./utils/find-target')

const { log } = console
const uuid = require('./utils/uuid.js')
module.exports = function store (state, emitter) {
  emitter.on('set-sprite-properties', () => {
    log('set-sprite-properties')
    state.sceneMetadata.spriteProperties.forEach(spriteData => {
      const target = findSpriteByName(state.vm, spriteData.name)
      spriteData.lists.forEach(list => {
        const newList = target.lookupOrCreateList(uuid(), list.name)
        newList.value = list.value
      })
      spriteData.variables.forEach(variable => {
        const newVar = target.lookupOrCreateVariable(uuid(), variable.name)
        newVar.value = variable.value
      })
      target.setXY(spriteData.x, spriteData.y)
      target.setDirection(spriteData.direction)
      target.setSize(spriteData.size)
      if (spriteData.currentCostume) {
        target.setCostume(spriteData.currentCostume)
      }
    })
  })

  emitter.on('apply-starting-glitches', () => {
    log('apply-starting-glitches')
    state.sceneMetadata.startingGlitches.forEach(g => {
      const target = state.vm.runtime.targets.find(
        t => t.sprite.name === g.spriteName
      )
      if (target) {
        emitter.emit('apply-glitch', g.glitchId, target.id)
        const { variables } = g
        if (variables) {
          variables.forEach(glitchVar => {
            let varTarget = target
            if (glitchVar.spriteName) {
              varTarget = state.vm.runtime.targets.find(
                t => t.sprite.name === glitchVar.spriteName
              )
            }
            const existingVar = Object.values(varTarget.variables).find(
              v => v.name === glitchVar.name
            )
            existingVar.value = glitchVar.value
          })
        }
      }
    })
  })
}
